import React from "react";
import { ProfileDepartmentInfoComponent } from "../../../services/types/ComponentTypes";
import { useDarkMode } from "../../../contexts/DarkModeContext";

interface ProfileDepartmentInfoProps {
    component: ProfileDepartmentInfoComponent;
    formData: any;
}

const ProfileDepartmentInfo: React.FC<ProfileDepartmentInfoProps> = ({
    component,
    formData,
}) => {
    const { isDarkMode } = useDarkMode();
    // Cast style to any to bypass type mismatch
    const containerStyle = {
        ...component.style,
        display: "flex",
        gap: 16,
        flexWrap: "wrap",
        borderTop: `1px solid ${isDarkMode ? "rgba(51,65,85,0.9)" : "rgba(148,163,184,0.35)"}`,
        paddingTop: 14,
        marginTop: 10,
    } as any;
    const labelColor = isDarkMode ? "#94a3b8" : "#64748b";
    const valueColor = isDarkMode ? "#e2e8f0" : "#0f172a";

    return (
        <div style={containerStyle}>
            {component.fields?.map((field: any, index: number) => {
                const value = formData[field.BindValue];
                return (
                    <div
                        key={index}
                        style={{
                            padding: "10px 12px",
                            borderRadius: 12,
                            border: `1px solid ${isDarkMode ? "rgba(51,65,85,0.9)" : "rgba(148,163,184,0.35)"}`,
                            background: isDarkMode ? "rgba(15,23,42,0.25)" : "rgba(248,250,252,0.85)",
                        }}
                    >
                        <div style={{ fontSize: 11, fontWeight: 700, color: labelColor, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 4 }}>
                            {field.label}
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: valueColor }}>
                            {value || "—"}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ProfileDepartmentInfo;
